export default {
  loginUrl: 'http://47.107.138.238/bsmtp/public', // 登录的url
  defaultUrl: 'http://47.107.138.238/bsmtp/public', // 默认的url
  refreshTime: { // 各个模块刷新时间
    statistic: 60 * 60 * 1000, // 60分
    receivingOrders: 20 * 60 * 1000,
    quantity: 24 * 60 * 60 * 1000,
    shippingSchedule: 20 * 60 * 1000,
    manHour: 60 * 60 * 1000,
    unusual: 60 * 60 * 1000
  },
  retryTime: 30 * 1000 // 异常重试时间
}



// WEBPACK FOOTER //
// ./src/js/config.js